// LHG: tema escuro forçado para toda a instância. Ignora a preferência do
// usuário (localStorage) e do sistema operacional — o dashboard é sempre dark.
export const setColorTheme = () => {
  document.body.classList.add('dark');
  document.documentElement.style.setProperty('color-scheme', 'dark');
};
